// Add-to-Home-Screen plumbing for the web build.
//
// Android Chrome fires `beforeinstallprompt` early in the page's life when
// install criteria are met (manifest + HTTPS). The listener must be armed
// before the event fires, so main.jsx calls armInstallPrompt() at module
// init; the stashed event lets our own button trigger the NATIVE install
// dialog later. iOS has no install API at all - the UI falls back to
// showing manual instructions (Share, then Add to Home Screen).

let deferredPrompt = null;
const listeners = new Set();

export function armInstallPrompt() {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault(); // suppress Chrome's own mini-infobar
    deferredPrompt = e;
    for (const cb of listeners) cb();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    for (const cb of listeners) cb();
  });
}

// True when running from a Home Screen icon (either platform).
export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(display-mode: standalone)')?.matches
    || window.navigator?.standalone === true;
}

export function canNativeInstall() {
  return deferredPrompt != null;
}

export function onInstallabilityChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

// Trigger the native install dialog (Android). Resolves true if the user
// accepted. The stashed event is single-use.
export async function promptInstall() {
  if (!deferredPrompt) return false;
  const evt = deferredPrompt;
  deferredPrompt = null;
  evt.prompt();
  try {
    const { outcome } = await evt.userChoice;
    return outcome === 'accepted';
  } catch {
    return false;
  }
}

export function isIos() {
  if (typeof navigator === 'undefined') return false;
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

const DISMISS_KEY = 'valkenhall.a2hsDismissed';

export function wasInstallPromptDismissed() {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
}

export function dismissInstallPrompt() {
  try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
}
